import React, { useEffect, useId, useMemo, useState } from "react";
import { ReactTooltip } from "tooltip";

function isDark(){
    return useMemo(() => {
        return document.querySelector('html').classList.contains('theme-dark');
    }, [])
}


export function DarkModeToogle(){
    const darkMode = isDark()
    const [dark, setDark] = useState(darkMode);
    
    useEffect(() => {
        document.querySelector('html').classList.toggle('theme-dark', dark);
        localStorage.theme = dark ? 'dark' : 'light';
    }, [dark])

  
    return <ReactTooltip className="mb-2 me-2 align-top" delay={300} tooltip={<>Alternar entre modo escuro e claro</>}>
        <button className="btn btn-primary" onClick={() => setDark(!dark)}><i className="fa fa-circle-half-stroke"></i> {dark ? 'Modo Claro' : 'Modo Escuro'}</button>
    </ReactTooltip>
}
